const TITLE = `Contact Gooding Christie’s`;
const DESCRIPTION =
  `Unfortunately, we could not verify your identity with the information provided. Please reach out to the Gooding Christie’s Bidder Registration staff at bids@goodingco.com or by phone at 310.899.1960. We will be happy to assist you.`;
export { TITLE, DESCRIPTION };
